import styled from 'styled-components';

export default styled.div`
  font-weight: ${({ font }) => font || '500'};
  padding: 1rem 0;
`;
